import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class CounterValidEmailTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

    getParams() {
        const params = super.getParams();
        return Object.assign({}, params, this.ownParams);
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        return `${http}${url}/services/user/countervalidemail`;
    }

    getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default CounterValidEmailTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/CounterValidEmailTask.js